// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function processError(err: any) {
  if (typeof err === "string") return err;
  if (err.response?.data?.message) {
    return "Error: " + err.response.data.message;
  }
  if (err.message) {
    return err.message;
  }
  return err.toString();
}

export const sleep = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const hasBit = (num: number, bit: number): boolean => (num & bit) !== 0;

export const getRelativeTime = function (timestamp: number): {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
} {
  const seconds = timestamp - Math.floor(Date.now() / 1000);
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secondsRemaining = Math.floor(seconds % 60);
  return {
    days,
    hours,
    minutes,
    seconds: secondsRemaining,
  };
};

export const pluralize = (count: number) => `${count === 1 ? "" : "s"}`;

export const partition = function <T>(array: T[], size: number): T[][] {
  return array.reduce<T[][]>(
    (result, value, index, array) =>
      index % size ? result : [...result, array.slice(index, index + size)],
    []
  );
};

export const longer = (a: string, b: string): string => {
  if (a.length > b.length) return a;
  return b;
};

export const formatNumber = (num: number, enforce = false): string => {
  const prefixes = ["", "k", "m", "b", "t"];
  let prefixIndex = 0;
  while (num >= 1000) {
    num /= 1000;
    prefixIndex++;
  }
  let numStr: string = num.toFixed(2);
  if (!enforce) numStr = Number(numStr).toString();
  if (enforce && numStr.length > 5) {
    numStr = numStr.slice(0, 5).replace(/\.$/, "");
  }

  return numStr + prefixes[prefixIndex];
};

export const randomID = (): string =>
  `ax-${Math.random().toString(36).slice(2)}`;
